import { VehiclePayload, VehicleResponse } from "api/types";
import customAxios from "config";
import { globalJson } from "global/global_json";
import toast from "react-hot-toast";
import { renterError } from "utils/errorMessage";

export const getVehicleData = async (
  params: any
): Promise<{
  data?: VehicleResponse[];
  error?: string;
}> => {
  try {
    const response = await customAxios.get("/api/fleet/", {
      params: {
        company_id: globalJson.company_id,
        start_time: params.start_time,
        end_time: params.end_time,
      },
    });
    return { data: response.data };
  } catch (error) {
    return { error: renterError(error, "vehicles") };
  }
};

export const getAvailableVehicleData = async (
  params: VehiclePayload
): Promise<{ data?: VehicleResponse[] | null; error?: string }> => {
  try {
    const response = await customAxios.get("/api/fleet/", {
      params: {
        available: params.available,
        start_time: params.start_time,
        end_time: params.end_time,
        pickup_location: params.pickup_location,
        drop_off_location: params.drop_off_location,
        company_id: globalJson.company_id,
        booking_id: params.booking_id,
        is_long_term_rental: params.is_long_term_rental,
        long_term_rental_nature: params.long_term_rental_nature,
      },
    });
    return { data: response.data }; // Return response data if successful
  } catch (error) {
    const message = renterError(error, "vehicles");
    toast.error(message);
    return { error: message };
  }
};

export const getUnavailableVehicleDataV2 = async (
  params: any,
  fleet_id: number,
  pickup_location_id?: number,
  exclude_advance_notice?: boolean,
): Promise<any> => {
  try {
    const queryParams: any = {
      start: params.start_date,
      end: params.end_date,
      location: pickup_location_id,
      booking_to_exclude: params.booking_to_exclude,
    };

    if (exclude_advance_notice) {
      queryParams.exclude_advance_notice = exclude_advance_notice;
    }

    const response = await customAxios.get(
      `/api/fleet/${fleet_id}/unavailability-v2/`,
      {
        params: queryParams,
      },
    );
    return { data: response.data }; // Return response data if successful
  } catch (error) {
    return { error: renterError(error, "vehicles") };
  }
};

export type OdometerImageType = "pre_odometer" | "post_odometer";

export interface OdometerReadResult {
  miles: number;
  raw_reading: number;
  unit: "mi" | "km" | "unknown";
  image_id: number;
  image_url: string;
  image_type: OdometerImageType;
}

export const readOdometer = async (
  image: File,
  bookingId: string | number,
  imageType: OdometerImageType,
): Promise<{ data?: OdometerReadResult; error?: string }> => {
  const formData = new FormData();
  formData.append("image", image);
  formData.append("booking_id", String(bookingId));
  formData.append("image_type", imageType);
  try {
    const response = await customAxios.post<OdometerReadResult>(
      "/api/fleet/read-odometer/",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return { data: response.data };
  } catch (error: any) {
    return { error: renterError(error, "vehicles") };
  }
};
